import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { FaGamepad, FaStar, FaUsers } from 'react-icons/fa';

function Home() {

  const features = [
    {
      icon: FaGamepad,
      title: 'Fun Games',
      description: 'Creative AI-powered games built with IoT',
    },
    {
      icon: FaStar,
      title: 'Learn & Play',
      description: 'Hands-on projects anyone can try',
    },
    {
      icon: FaUsers,
      title: 'Community',
      description: 'Share and learn with makers everywhere',
    },
  ];

  const container = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2,
      },
    },
  };

  const item = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
    },
  };

  return (
    <div className="w-full" style={{ background: 'linear-gradient(to bottom right, #3B0764, #6B21A8, #7C3AED, #8B5CF6)' }}>
      {/* Features Section - Purple Gradient */}
      <section className="py-16 md:py-24 px-4" style={{ background: 'linear-gradient(to bottom, rgba(59,7,100,0.9), rgba(107,33,168,0.9))' }}>
        <div className="container mx-auto max-w-5xl">
          <motion.h3
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            className="text-4xl md:text-5xl font-black text-center mb-16 font-heading"
            style={{ fontFamily: "'Bangers', cursive", color: '#FDE047', WebkitTextStroke: '1px #0F0A1A', textShadow: '2px 2px 0 #0F0A1A' }}
          >
            ✨ What I Do ✨
          </motion.h3>

          <motion.div
            className="grid grid-cols-1 md:grid-cols-3 gap-8"
            variants={container}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
          >
            {features.map((feature, index) => {
              const IconComponent = feature.icon;
              return (
                <motion.div
                  key={index}
                  variants={item}
                  whileHover={{ y: -8, rotate: 2 }}
                  className="p-8 rounded-2xl border-4 transition-all"
                  style={{ background: 'linear-gradient(135deg, #EF4444 0%, #DC2626 100%)', borderColor: '#0F0A1A', boxShadow: '4px 4px 0 #0F0A1A' }}
                >
                  <div className="text-6xl mb-4">
                    <IconComponent style={{ color: '#FDE047' }} />
                  </div>
                  <h4 className="text-3xl font-black text-white mb-3 font-heading" style={{ fontFamily: "'Bangers', cursive", WebkitTextStroke: '1px #0F0A1A' }}>
                    {feature.title}
                  </h4>
                  <p className="text-white font-semibold text-lg" style={{ fontFamily: "'Fredoka One', cursive", WebkitTextStroke: '0.5px #0F0A1A' }}>
                    {feature.description}
                  </p>
                </motion.div>
              );
            })}
          </motion.div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 md:py-20 px-4" style={{ background: 'linear-gradient(to bottom right, #3B0764, #6B21A8)' }}>
        <motion.div
          className="container mx-auto max-w-3xl text-center"
          initial={{ opacity: 0, scale: 0.9 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
        >
          <h3 className="text-4xl md:text-5xl font-black text-white mb-6 font-heading drop-shadow-lg" style={{ fontFamily: "'Bangers', cursive", color: '#FDE047', WebkitTextStroke: '1px #0F0A1A', textShadow: '3px 3px 0 #0F0A1A' }}>
            🎮 READY TO EXPLORE? 🎮
          </h3>
          <p className="text-xl md:text-2xl text-yellow-100 mb-8 leading-relaxed font-bold" style={{ fontFamily: "'Fredoka One', cursive", color: '#FDE047', WebkitTextStroke: '0.5px #0F0A1A' }}>
            Check out my latest games and projects!
          </p>
          <Link to="/my-games">
            <motion.button
              whileHover={{ scale: 1.15, rotate: 3 }}
              whileTap={{ scale: 0.95 }}
              className="px-12 py-6 bg-yellow-300 text-purple-900 font-black text-2xl rounded-3xl hover:bg-yellow-400 transition-all shadow-cartoon-lg border-4 border-yellow-400 animate-jiggle"
              style={{ fontFamily: "'Bangers', cursive" }}
            >
              LET'S GO! 🚀
            </motion.button>
          </Link>
        </motion.div>
      </section>
    </div>
  );
}

export default Home;
